import React from 'react';
import Browser from '@wetransfer/concorde-browser';

import Assets from '@app/assets';
import Icon from '@component/icon';

const queryParam = '?trk=add-to-home-screen';

export default class AddToHomeTip extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.container = React.createRef();
  }

  componentDidUpdate(prevState) {
    // Scroll to top if component was closed and got opened by user click
    if (!prevState.open && this.state.open) {
      this.container.current.scrollIntoView(true);
    }
  }

  openBookmarkTip() {
    this.setState({ open: true });
    // adding the query param only once
    if (window.location.pathname !== queryParam) {
      history.pushState(null, '', queryParam);
    }
  }

  determineAssets = () => {
    if (Browser.isAndroid) {
      return {
        variant: 'android',
        settingsIcon: Assets.lookup('chrome-share-icon.png'),
        image: Assets.lookup(
          'transfer_window/Instruction_add_to_home_Android.png'
        ),
      };
    }

    if (Browser.isIphone) {
      return {
        variant: 'ios',
        settingsIcon: Assets.lookup('safari-share-icon.png'),
        image: Assets.lookup('transfer_window/Instruction_add_to_home_IOS.png'),
      };
    }

    return { variant: null };
  };

  render() {
    const { variant, settingsIcon, image } = this.determineAssets();

    // Stop everything if device not supported.
    if (!variant) {
      return null;
    }

    const intro = (
      <div className="bookmark__intro" id="bookmark__intro">
        <div>
          <img
            src={Assets.lookup('apple-touch-icon-180x180-precomposed.png')}
            alt="bookmark logo"
            className={`bookmark__intro-logo bookmark__intro-logo--${variant}`}
          />
        </div>
        <div>
          <span>Quick transfer next time</span>
          <span className="bookmark__link">
            <button onClick={() => this.openBookmarkTip()}>
              Add us to home screen
              <Icon type="Arrow" orientation="bottom" />
            </button>
          </span>
        </div>
      </div>
    );

    const settings = (
      <div className="bookmark__settings">
        Tap{' '}
        <img
          src={settingsIcon}
          alt="settings icon"
          className="bookmark__settings--icon"
        />{' '}
        and then select
        <br />
        'Add to Home Screen'
      </div>
    );

    const steps = (
      <div className="bookmark__steps bookmark-steps">
        <img
          src={image}
          alt="tutorial"
          className={`bookmark__steps-infographic bookmark__steps-infographic--${variant}`}
        />
      </div>
    );

    if (this.state.open) {
      return (
        <div className="bookmark bookmark--open" ref={this.container}>
          {intro}
          {settings}
          {steps}
        </div>
      );
    }

    return (
      <div className="bookmark" ref={this.container}>
        {intro}
      </div>
    );
  }
}
